import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpParams,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class OptionMonitorService {

  constructor(private http: HttpClient) { }

  getSliderExpirations(stockId, regionId): Observable<any> {
    const params: HttpParams = new HttpParams()
      .append('stockId', stockId)
      .append('regionId', regionId);
    return this.http.get('/options-monitor/expirations/volatility', {observe: 'response', params});
  }

  // Осторожно, этот метод используется неявно!
  public getResult(params): Observable<HttpResponse<any>> {
    return this.http.get<any>('/options-monitor/listOptionDataRow', {observe: 'response', params});
  }

  public getFuturesResult(params): Observable<HttpResponse<any>> {
    return this.http.get<any>('/futures-options-monitor/listOptionDataRow', {observe: 'response', params});
  }

  public getFilterTypes(): Observable<HttpResponse<any>> {
    return this.http.get<any>('/options-monitor/expirations/filterTypes', {observe: 'response'});
  }

  public getFutureFilterTypes(): Observable<HttpResponse<any>> {
    return this.http.get<any>('/futures-options-monitor/filterTypes');
  }

  public getExpiration(params): Observable<HttpResponse<any>> {
    return this.http.get('/options-monitor/expirations', {observe: 'response', params});
  }

  public getFutureExpiration(params): Observable<HttpResponse<any>> {
    return this.http.get('/futures-options-monitor/expirations', {observe: 'response', params});
  }

  getExpirationRt(stockId): Promise<any> {
    return this.http.get(`/options-monitor/expirationsRt?stockId=${stockId}`)
      .toPromise()
      .then(response => response, () => [])
      .catch(this.handleErrorPromise);
  }

  downloadCSVBlob(id, regionId, expirations, filterType, center, strikesN, type, columns, symbol, mode, tabType, futExpDate?) {
    let params = '';
    const expDate = tabType === 'instrument' ? '&expDate=' : '&optExpDates=';
    params += tabType === 'instrument' ? 'stockId=' + String(id) : 'underlyingId=' + String(id);
    if (tabType === 'instrument') {
      params += '&rtMode=' + String(mode).split('_')[0].toLowerCase();
    }
    params += '&center=' + String(center);
    params += '&regionId=' + String(regionId);

    if (tabType === 'instrument') {
      if (Array.isArray(expirations)) {
        expirations.forEach(item => {
          params += expDate + String(item);
        });
      } else {
        params += expDate + String(expirations);
      }
    } else {
      const exp = Array.isArray(expirations) ? expirations : [expirations];
      params += expDate + exp.join(',');
    }

    params += '&symbol=' + String(symbol);
    params += '&filterType=' + String(filterType);
    params += '&strikesN=' + String(strikesN);
    params += '&type=' + (tabType === 'instrument' ? String(type) : String(type).substring(0, 1));
    columns.forEach(item => {
      params += '&columns=' + String(item);
    });

    if (tabType === 'future') {
      params += '&futExpDate=' + String(futExpDate);
    }

    const endpoint = tabType === 'instrument' ? '/options-monitor' : '/futures-options-monitor';

    return this.http.get(`${endpoint}/listOptionDataRow/csv?${params}`, {responseType: 'text'}).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  getColumns(type: string): Observable<any> {
    const endpoint = type === 'instrument' ? '/iv-live/assets/option_monitor_columns' : '/iv-live/assets/futures_option_monitor_columns';
    return this.http.get(`${endpoint}.json?version=5`);
  }

  private handleErrorPromise(error: any): Promise<any> {
    return Promise.reject(error.message || error);
  }
}
